import { mixpanel } from '@fiverr-private/obs';

export const reportMixpanelEvent = ({ eventName, ...params }) => mixpanel.track(eventName, params);
